import { render, staticRenderFns } from "./Currency.vue?vue&type=template&id=7d57591a&"
import script from "./Currency.vue?vue&type=script&lang=ts&"
export * from "./Currency.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d57591a')) {
      api.createRecord('7d57591a', component.options)
    } else {
      api.reload('7d57591a', component.options)
    }
    module.hot.accept("./Currency.vue?vue&type=template&id=7d57591a&", function () {
      api.rerender('7d57591a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/Currency.vue"
export default component.exports